module.exports = __webpack_public_path__ + "img/wps.f1f9fad8.jpg";